import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import style from './sessionNotice.module.scss';

/**
 * Light blue notice used on the Quick Apply contact step to explain that basic
 * details are kept for the current browser session only.
 *
 * `variant="restored"` renders the leading restore icon and a trailing info icon
 * (both decorative); the default renders a single leading info icon.
 */
function SessionNotice({ message, variant }) {
  const isRestored = variant === 'restored';

  return (
    <div className={`${style.notice} ${isRestored ? style.restored : ''}`}>
      {isRestored ? (
        <RotateLeftIcon className={style.icon} aria-hidden="true" />
      ) : (
        <InfoOutlinedIcon className={style.icon} aria-hidden="true" />
      )}
      <p className={style.message}>{message}</p>
      {isRestored && <InfoOutlinedIcon className={`${style.icon} ${style.trailingIcon}`} aria-hidden="true" />}
    </div>
  );
}

export default SessionNotice;
